import { FieldSet, IFieldSetProps } from "nsitools-react";
import React from "react";
import styled from "styled-components";

export const StyledFieldSet = styled(FieldSet)``;

export interface IDrupalFieldSetProps extends IFieldSetProps {
  divid?: boolean;
}

export const DrupalFieldSet: React.FC<IDrupalFieldSetProps> = (props) => {
  return <StyledFieldSet {...props} divider={props.divid} />;
};
